import { inject, Injectable } from '@angular/core';
import { ActiveToast, ToastrService } from 'ngx-toastr';
import { BatchDocumentToastComponent } from './toast';
import {
  BatchDocumentToastParams,
  BatchDocumentToastPayload,
} from './batch-document-toast.type';

@Injectable({
  providedIn: 'root',
})
export class BatchDocumentToastService {
  private readonly toastrService = inject(ToastrService);

  public showProcessingToast(params: BatchDocumentToastParams): void {
    this.showToast({
      title: params.title,
      subtitle: params.subtitle,
      showDownload: false,
    });
  }

  public showDocumentReadyToast(
    params: BatchDocumentToastParams
  ): ActiveToast<void> {
    return this.showToast({
      title: params.title,
      subtitle: params.subtitle,
      showDownload: !!(params.buttonName && params.documentId),
      buttonName: params.buttonName,
      documentId: params.documentId,
    });
  }

  private showToast(payload: BatchDocumentToastPayload): ActiveToast<void> {
    return this.toastrService.info('', '', {
      toastComponent: BatchDocumentToastComponent,
      payload,
      enableHtml: false,
      toastClass: 'ngx-toastr batch-document-toast-container',
      closeButton: false,
      tapToDismiss: false,
      positionClass: 'toast-bottom-right',
      timeOut: payload.showDownload ? 0 : 7000,
      extendedTimeOut: payload.showDownload ? 0 : 1000,
      disableTimeOut: payload.showDownload,
    });
  }
}
